import React from 'react';
import { FormikInput } from 'components/UiKit/FormikFields';
import PersonFieldLabel from '../PersonFieldLabel';

function ZipField() {
  return (
    <div className="my-4 w-full">
      <div className="block ml-6">
        <div className="w-full">
          <PersonFieldLabel htmlFor="postal-code-input">
            Zip Code
          </PersonFieldLabel>
        </div>
        <div className="w-full">
          <FormikInput id="postal-code-input" name="postalCode" />
        </div>
      </div>
    </div>
  );
}

export default ZipField;
